<template>
  <div class="page-upload-auth">
    <!-- 审核结果 -->
    <el-alert
      v-if="authStatus !== 1 && (!certInfo.riskErrorMsg || certInfo.riskErrorMsg.length === 0)"
      class="mb20"
      :title="authRes.title"
      :description="authRes.msg"
      :type="authRes.type"
      :closable="false"
      show-icon
    ></el-alert>
    <!-- 风控提示 -->
    <el-alert
      v-if="authStatus === 4 && certInfo.riskErrorMsg && certInfo.riskErrorMsg.length > 0"
      class="mb20"
      title="识别结果如下请确认"
      :description="certInfo.riskErrorMsg.join('、')"
      type="error"
      :closable="false"
      show-icon
    ></el-alert>
    <div class="top-box clearfix">
      <p class="fl big-title">{{ agent ? '企业委托代办人认证' : '企业账号法人认证' }}</p>
    </div>
    <div class="cert-result-box">
      <!-- 认证信息 -->
      <p class="item-title">营业执照信息</p>
      <el-alert
        v-if="authRes.type === 'error' && certInfo.licenseErrorMsg && certInfo.licenseErrorMsg.length !== 0"
        title="识别结果如下请确认："
        :type="authRes.type"
        show-icon
        :closable="false"
      >
        <div>
          <div v-for="(msg, index) in certInfo.licenseErrorMsg" :key="index">{{ msg }}</div>
        </div>
      </el-alert>
      <div v-loading="loading" class="info-box">
        <div class="left-info-box">
          <el-form
            v-if="certInfo.licenseData"
            ref="licenseForm"
            :model="certInfo.licenseData"
            :rules="licenseRules"
            label-width="120px"
            class="license-form"
            :disabled="!canChange"
          >
            <el-form-item label="营业执照:" prop="licenseImgUrl" >
              <div class="upload-box clearfix">
                <UploadImg
                  :img-info="imgInfo"
                  prop="licenseImgUrl"
                  size="big"
                  clstag="license"
                  :image-type="3"
                  :file-list="certInfo.licenseImgUrlPath ? [{name: '营业执照.jpg', url: certInfo.licenseImgUrlPath}] : []"
                  :can-change="canChange"
                  @updateImg="updateAuthForm"
                />
              </div>
              <p class="img-desc">图片文件支持gif、jpg、jpeg、png、bmp，大小不超过5MB</p>
            </el-form-item>
            <el-form-item label="名称:" prop="companyName" >
              <el-input v-model.trim="certInfo.licenseData.companyName" placeholder="请输入公司名称"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码:" prop="uniNo" >
              <el-input v-model.trim="certInfo.licenseData.uniNo" placeholder="请输入18位统一社会信用代码"></el-input>
            </el-form-item>
            <el-form-item label="住所:" prop="companyAreaId" placeholder="请输入18位统一社会信用代码" class="area-select">
              <el-select v-model="company.areaLevel1" placeholder="省" value-key="id" class="w100">
                <el-option
                  v-for="(area) in areaLevel1Info"
                  :key="area.id"
                  :label="area.name"
                  :value="area"
                ></el-option>
              </el-select>
              <el-select v-model="company.areaLevel2" placeholder="市" value-key="id" class="w100">
                <el-option
                  v-for="(area) in areaLevel2Info"
                  :key="area.id"
                  :label="area.name"
                  :value="area"
                ></el-option>
              </el-select>
              <el-select v-model="company.areaLevel3" placeholder="区/县" value-key="id" class="w100">
                <el-option
                  v-for="(area) in areaLevel3Info"
                  :key="area.id"
                  :label="area.name"
                  :value="area"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="住所详细地址:" prop="companyAddress" >
              <el-input v-model.trim="certInfo.licenseData.companyAddress" placeholder="请输入住所详细地址"></el-input>
            </el-form-item>
            <el-form-item label="经营范围:" prop="licenseScope" >
              <el-input v-model.trim="certInfo.licenseData.licenseScope" type="textarea" :autosize="{ minRows: 5 }" placeholder="请输入经营范围"></el-input>
            </el-form-item>
            <el-form-item label="营业期限（止）:" prop="isLongTerm" >
              <el-radio-group v-model="certInfo.licenseData.isLongTerm">
                <el-radio label="1">长期有效</el-radio>
                <el-radio label="0">固定日期</el-radio>
              </el-radio-group>
              <el-date-picker
                v-if="!Number(certInfo.licenseData.isLongTerm)"
                v-model="certInfo.licenseData.timeEnd"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                class="ml10"
                style="width: 182px;"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div class="right-img-box">
          <div class="demo-box">
            <p class="demo-title">营业执照示例：</p>
            <div class="demo-img-box">
              <img src="//img20.360buyimg.com/da/jfs/t1/173324/39/1119/162571/6062d4b8E7b5e7898/3cca022ec42bc062.png" class="demo-license"/>
            </div>
          </div>
          <!-- <UploadRemark demo-path="//img20.360buyimg.com/da/jfs/t1/159167/11/2105/826309/5ff6d06aE0a70249e/4c99069ceac9e69a.png" /> -->
        </div>
      </div>

      <p class="item-title">法人证件</p>
      <el-alert
        v-if="authRes.type === 'error' && certInfo.idCardErrorMsg && certInfo.idCardErrorMsg.length !== 0"
        title="识别结果如下请确认："
        :type="authRes.type"
        show-icon
        :closable="false"
      >
        <div>
          <div v-for="(msg, index) in certInfo.idCardErrorMsg" :key="index">{{ msg }}</div>
        </div>
      </el-alert>
      <div v-loading="loading" class="info-box">
        <div class="left-info-box">
          <el-form
            v-if="certInfo.idCardData"
            ref="idCardForm"
            :model="certInfo.idCardData"
            :rules="idCardRules"
            label-width="120px"
            class="idCard-form"
            :disabled="!canChange"
          >
            <el-form-item label="身份证照片:" prop="idCardFrontImgUrl" >
              <div class="upload-box clearfix">
                <UploadImg
                  :img-info="imgInfo"
                  text="头像面"
                  size="medium"
                  prop="idCardFrontImgUrl"
                  clstag="idCard_font"
                  :image-type="1"
                  :file-list="certInfo.idCardFrontImgUrlPath ? [{name: '法人证件头像面.jpg', url: certInfo.idCardFrontImgUrlPath}] : []"
                  :can-change="canChange"
                  @updateImg="updateAuthForm"
                />
                <UploadImg
                  :img-info="imgInfo"
                  text="国徽面"
                  size="medium"
                  prop="idCardBackImgUrl"
                  clstag="idCard_end"
                  :image-type="2"
                  :file-list="certInfo.idCardBackImgUrlPath ? [{name: '法人证件国徽面.jpg', url: certInfo.idCardBackImgUrlPath}] : []"
                  :can-change="canChange"
                  @updateImg="updateAuthForm"
                />
              </div>
              <p class="img-desc">图片文件支持gif、jpg、jpeg、png、bmp，大小不超过5MB</p>
            </el-form-item>
            <el-form-item label="证件类型:" prop="cardType" >
              <el-select v-model="certInfo.idCardData.cardType" style="width:200px">
                <el-option
                  label="中华人民共和国居民身份证"
                  :value="1"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名:" prop="name" >
              <el-input v-model.trim="certInfo.idCardData.name" placeholder="请输入法人姓名"></el-input>
            </el-form-item>
            <el-form-item label="证件号码:" prop="cardNo" >
              <el-input v-model.trim="certInfo.idCardData.cardNo" placeholder="请输入证件号码"></el-input>
            </el-form-item>
            <el-form-item label="有效期限（止）:" prop="isLongTerm" >
              <el-radio-group v-model="certInfo.idCardData.isLongTerm">
                <el-radio label="1">长期有效</el-radio>
                <el-radio label="0">固定日期</el-radio>
              </el-radio-group>
              <el-date-picker
                v-if="!Number(certInfo.idCardData.isLongTerm)"
                v-model="certInfo.idCardData.timeEnd"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                class="ml10"
                style="width: 182px;"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div class="right-img-box card-right">
          <div class="demo-box">
            <p class="demo-title">身份证示例：</p>
            <div class="demo-img-box">
              <img src="//img20.360buyimg.com/da/jfs/t1/175554/16/1112/68433/6062d4b7E21de8d85/a07ef24d61c85539.png" class="demo-id-card mr20"/>
              <img src="//img20.360buyimg.com/da/jfs/t1/173326/28/1140/89578/6062d4b7E57bd7283/9b964d94e29b2814.png" class="demo-id-card"/>
            </div>
          </div>
        </div>
      </div>

      <!-- 代办人认证表单 -->
      <template v-if="agent">
        <p class="item-title">代办人证件</p>
        <el-alert
          v-if="authRes.type === 'error' && certInfo.agentIdCardErrorMsg && certInfo.agentIdCardErrorMsg.length !== 0"
          title="识别结果如下请确认："
          :type="authRes.type"
          show-icon
          :closable="false"
        >
          <div>
            <div v-for="(msg, index) in certInfo.agentIdCardErrorMsg" :key="index">{{ msg }}</div>
          </div>
        </el-alert>
        <div v-loading="loading" class="info-box">
          <div class="left-info-box">
            <el-form
              ref="agentForm"
              :model="certInfo"
              label-width="120px"
              :disabled="!canChange"
            >
              <el-form-item label="授权委托书:">
                <div class="upload-box clearfix">
                  <UploadImg
                    :img-info="imgInfo"
                    size="medium"
                    prop="agentPowerAttorneyImgUrl"
                    clstag="idCard_end"
                    :image-type="-1"
                    :file-list="certInfo.agentPowerAttorneyImgUrlPath ? [{name: '授权委托书.jpg', url: certInfo.agentPowerAttorneyImgUrlPath}] : []"
                    :can-change="canChange"
                    @updateImg="updateAuthForm"
                  />
                </div>
                <p class="img-desc">
                  需要<a class="url-link" href="https://storage.360buyimg.com/jmqy-file/%E4%BB%A3%E5%8A%9E%E4%BA%BA%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6.docx">下载授权委托书模版</a>打印并上传清晰完整的授权委托书照片，其中正文中被委托人姓名和证件号码需要机打，落款需要加盖企业公章。
                </p>
                <p class="img-desc">图片文件支持gif、jpg、jpeg、png、bmp，大小不超过5MB</p>
              </el-form-item>
              <el-form-item label="代办人身份证:">
                <div class="upload-box clearfix">
                  <UploadImg
                    :img-info="imgInfo"
                    text="头像面"
                    size="medium"
                    prop="agentIdCardFrontImgUrl"
                    clstag="idCard_font"
                    :image-type="-1"
                    :file-list="certInfo.agentIdCardFrontImgUrlPath ? [{name: '代办人证件头像面.jpg', url: certInfo.agentIdCardFrontImgUrlPath}] : []"
                    :can-change="canChange"
                    @updateImg="updateAuthForm"
                  />
                  <UploadImg
                    :img-info="imgInfo"
                    text="国徽面"
                    size="medium"
                    prop="agentIdCardBackImgUrl"
                    clstag="idCard_end"
                    :image-type="-1"
                    :file-list="certInfo.agentIdCardBackImgUrlPath ? [{name: '法人证件国徽面.jpg', url: certInfo.agentIdCardBackImgUrlPath}] : []"
                    :can-change="canChange"
                    @updateImg="updateAuthForm"
                  />
                </div>
                <p class="img-desc">图片文件支持gif、jpg、jpeg、png、bmp，大小不超过5MB</p>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>

      <p class="item-title">其他信息</p>
      <el-form
        ref="phoneForm"
        v-loading="loading"
        :model="certInfo"
        :rules="phoneRules"
        label-width="108px"
        class="phone-form"
        :disabled="!canChange"
      >
        <el-form-item label="联系人手机号:" prop="phone" >
          <el-input v-model.trim="certInfo.phone" placeholder="请输入公司名称" style="width: 340px" :maxlength="11" @keydown="() => {return false;}">
            <template slot="prepend">中国 +86</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button v-if="canChange && Number(authStatus) === 1" v-loading="loading" size="large" type="primary" clstag="pageclick|keycount|info_legalAuth|submit" @click="checkAll">提交认证</el-button>
        <el-button v-if="canChange && Number(authStatus) === 4" v-loading="loading" size="large" type="primary" clstag="pageclick|keycount|info_legalAuth|modify" @click="checkAll">确认修改</el-button>
        <el-tooltip v-if="Number(authStatus) === 4 || Number(authStatus) === 2" effect="dark" content="选择认证类型当前页面信息将清空重新提交" placement="top-start">
          <el-button plain size="large" clstag="pageclick|keycount|license_fail_choose|01" @click="revoke">选择认证类型</el-button>
        </el-tooltip>
      </div>
    </div>

    <!-- 人脸识别 -->
    <FaceRecognition
      v-if="faceVisible"
      :id-card-data="certInfo.idCardData"
      :visible="faceVisible"
      @close="closeFace"
    />
  </div>
</template>

<script>
import { ValidRegType } from '@jd/taurus';
import store from '@/store';
import {
  certView,
  certSubmit,
  areaList,
  downloadBase64Img,
  tenantPhone,
  reSelectCertMethod,
} from '@/api/apis/auth';
import UploadImg from './components/uploadImg.vue';
import FaceRecognition from './components/faceRecognition.vue';

export default {
  name: 'UploadAuth',
  components: {
    UploadImg,
    FaceRecognition,
  },
  props: {
    agent: Boolean,
  },
  data() {
    // 手机号校验
    const checkPhone = (rule, value, callback) => {
      const phoneReg = /^(0086)?1\d{10}$/;
      if (!value || value === undefined) {
        callback(new Error('请输入手机号'));
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      }
      callback();
    };

    // 营业执照 - 营业期限校验
    const checkLicenseIsLong = (rule, value, callback) => {
      if (value === undefined) {
        callback(new Error('请选择营业执照期限类型'));
      } else if (Number(value) === 0 && !this.certInfo.licenseData.timeEnd) {
        callback(new Error('请选择营业执照期限终止日期'));
      }
      callback();
    };

    // 身份证 - 有效期限校验
    const checkIdCardIsLong = (rule, value, callback) => {
      if (value === undefined) {
        callback(new Error('请选择身份证期限类型'));
      } else if (Number(value) === 0 && !this.certInfo.idCardData.timeEnd) {
        callback(new Error('请选择身份证期限终止日期'));
      }
      callback();
    };

    // 地区选择校验
    const checkAreaId = (rule, value, callback) => {
      if (this.areaIds && this.areaIds.length < 3) {
        callback(new Error('请完善住所信息'));
      } else if (this.areaIds && this.areaIds.filter((item) => !ValidRegType.validReg(item, 'number')).length !== 0) {
        callback(new Error('请完善住所信息'));
      }
      callback();
    };

    // 营业执照 & 身份上传
    const checkImg = (rule, value, callback) => {
      callback();
    };

    return {
      certInfo: {
        auditing: 1,
        idCardErrorMsg: [],
        idCardData: {
          cardType: 1,
          cardNo: '',
          name: '',
          isLongTerm: '1',
          timeEnd: null,
        },
        idCardBackImgUrl: '',
        idCardFrontImgUrl: '',
        licenseErrorMsg: [],
        licenseData: {
          companyAddress: '',
          companyAreaId: '',
          companyCityId: '',
          companyName: '',
          companyProvinceId: '',
          isLongTerm: '1',
          licenseScope: '',
          timeEnd: null,
          uniNo: '',
        },
        licenseUrl: '',
        agentIdCardErrorMsg: [],
        agentPowerAttorneyImgUrl: '',
        agentIdCardFrontImgUrl: '',
        agentIdCardBackImgUrl: '',
        phone: '',
        riskErrorMsg: [],
      },
      licenseRules: {
        licenseImgUrl: [
          { required: true, validator: checkImg, trigger: 'change' },
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'change' },
        ],
        uniNo: [
          { required: true, message: '请输入18位统一社会信用代码', trigger: 'change' },
        ],
        companyAreaId: [
          { required: true, validator: checkAreaId, trigger: 'change' },
        ],
        companyAddress: [
          { required: true, message: '请输入住所详细地址', trigger: 'change' },
        ],
        isLongTerm: [
          { required: true, validator: checkLicenseIsLong, trigger: 'change' },
        ],
        licenseScope: [
          { required: true, message: '请输入经营范围', trigger: 'change' },
        ],
      },
      idCardRules: {
        idCardFrontImgUrl: [
          { required: true, validator: checkImg, trigger: 'change' },
        ],
        cardType: [
          { required: true, message: '请选择证件类型', trigger: 'change' },
        ],
        name: [
          { required: true, message: '请输入法人姓名', trigger: 'change' },
        ],
        cardNo: [
          { required: true, message: '请输入法人身份证号', trigger: 'change' },
        ],
        isLongTerm: [
          { required: true, validator: checkIdCardIsLong, trigger: 'change' },
        ],
      },
      phoneRules: {
        phone: [
          { required: true, validator: checkPhone, trigger: 'change' },
        ],
      },
      imgInfo: {
        size: 5,
        demoPath: 'abc',
      },
      areaLevel1Info: [], // 省
      areaLevel2Info: [], // 市
      areaLevel3Info: [], // 区
      company: {
        areaLevel1: null,
        areaLevel2: null,
        areaLevel3: null,
      },
      loading: true,
      init: false, // 判断是否是第一次回显省市区
      faceVisible: false, // 弹窗展示人脸识别
      eid: '', // 设备指纹
    };
  },
  computed: {
    // 认证状态
    authStatus() {
      return this.$store.state.authStatus;
    },
    // 是否还可修改提交
    canChange() {
      if (typeof this.certInfo.auditing === 'undefined') {
        return false;
      }
      return !!Number(this.certInfo.auditing) && [1, 4].includes(Number(this.authStatus));
    },
    // 认证结果提示
    authRes() {
      const list = {
        1: {
          text: '待认证',
          type: 'info',
        },
        2: {
          text: '审核中',
          type: 'warning',
        },
        3: {
          text: '已认证',
          type: 'success',
        },
        4: {
          text: '认证失败',
          type: 'error',
        },
      };
      return {
        title: list[Number(this.authStatus)].text,
        msg: this.certInfo.auditMsg || '',
        type: list[Number(this.authStatus)].type,
      };
    },
    // 地区ids
    areaIds() {
      const areaIds = [];
      Object.keys(this.company).forEach((key) => {
        const item = this.company[key];
        if (item && typeof item.id !== 'undefined') {
          areaIds.push(item.id);
        }
      });
      return areaIds;
    },
  },
  watch: {
    'company.areaLevel1': {
      handler() {
        if (this.company.areaLevel1 && Object.keys(this.company.areaLevel1).length !== 0) {
          this.getAreaInfo(2, this.company.areaLevel1);
          if (!this.init) {
            this.company.areaLevel2 = null;
            this.company.areaLevel3 = null;
          }
        }
      },
      deep: true,
    },
    'company.areaLevel2': {
      handler() {
        if (this.company.areaLevel2 && Object.keys(this.company.areaLevel2).length !== 0) {
          this.getAreaInfo(3, this.company.areaLevel2);
          if (!this.init) {
            this.company.areaLevel3 = null;
          } else {
            this.init = false;
          }
        }
      },
      deep: true,
    },
  },
  created() {
    this.getEid();
    if (this.authStatus === 1) {
      this.initAuth();
    } else {
      this.getAuthInfo();
    }
  },
  methods: {
    // 获取设备指纹
    getEid() {
      return new Promise((resolve, reject) => {
        if (this.eid) {
          resolve(this.eid);
        } else {
          try {
            window.getJdEid((eid) => {
              this.eid = eid;
              resolve(eid);
            });
          } catch (e) {
            reject(new Error('获取设备指纹失败！请刷新后重试'));
          }
        }
      });
    },
    // 初始化展示
    initAuth() {
      this.loading = false;
      this.init = true;
      this.getAreaInfo(1);
      // 省市区回显
      this.initArea();
      this.getPhone();
    },
    // 重新选择认证方式
    async revoke() {
      const res = await reSelectCertMethod();
      const { code, message } = res;

      if (code === 200) {
        this.$router.push({ path: '/info/select' });
      } else {
        this.$message.error(message || '服务器异常，请稍后重试');
      }
    },
    // 查询管理员手机号
    async getPhone() {
      const res = await tenantPhone();
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        this.certInfo.phone = data.phone || '';
        // this.certInfo.phone = data.phone.slice(3, data.phone.length) || '';
      } else {
        console.log('获取管理员手机号失败');
      }
    },
    // 解析身份证正反、营业执照图片
    decodeImg(certInfo) {
      let decodeList = [
        { path: 'idCardBackImgUrl', prop: 'idCardBackImgUrlPath' },
        { path: 'idCardFrontImgUrl', prop: 'idCardFrontImgUrlPath' },
        { path: 'licenseImgUrl', prop: 'licenseImgUrlPath' },
      ];
      // 代办人认证，解析授权书和身份证
      if (this.agent) {
        decodeList = decodeList.concat([
          { path: 'agentPowerAttorneyImgUrl', prop: 'agentPowerAttorneyImgUrlPath' },
          { path: 'agentIdCardFrontImgUrl', prop: 'agentIdCardFrontImgUrlPath' },
          { path: 'agentIdCardBackImgUrl', prop: 'agentIdCardBackImgUrlPath' },
        ]);
      }
      decodeList.forEach(async (item) => {
        await this.download(certInfo[item.path], item.prop);
      });
    },
    // 解析加密地址图片流信息
    async download(imgPath, key) {
      const formData = new FormData();
      formData.append('filePath', imgPath);
      const res = await downloadBase64Img(formData);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        this.certInfo[key] = `data:image/jpeg;base64,${data.image}`;
        this.$forceUpdate();
      } else {
        this.$message.error('图片地址下载失败');
      }
    },
    // 查询验证状态
    async getAuthInfo() {
      const res = await certView({});
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      this.loading = true;
      if (code === 200) {
        const info = { ...this.certInfo, ...data };
        data.idCardData.cardType = 1; // 补充 - 证件类型
        data.licenseData.timeEnd = info.licenseData.timeEnd || null;
        data.licenseData.isLongTerm = info.licenseData.isLongTerm || '0';
        data.idCardData.timeEnd = info.idCardData.timeEnd || null;
        data.idCardData.isLongTerm = info.idCardData.isLongTerm || '0';

        this.certInfo = info;

        // 更新认证状态
        store.commit('setAuthStatus', Number(this.certInfo.authStatus));
        // 未认证， 去上传页
        if (Number(this.certInfo.authStatus) === 1) {
          this.initAuth();
        } else {
          this.init = true;
          this.getAreaInfo(1);
          // 省市区回显
          this.initArea();
          // 解析身份证正反、营业执照图片
          await this.decodeImg(data);
        }
      } else {
        this.$message.error(message || '获取认证信息失败');
      }
      this.loading = false;
    },
    // 省市区回显 - 数据初始化
    initArea() {
      const { companyAreaId, companyCityId, companyProvinceId } = this.certInfo.licenseData;
      const relationList = [{
        key: 'companyProvinceId',
        level: 1,
      }, {
        key: 'companyCityId',
        level: 2,
      }, {
        key: 'companyAreaId',
        level: 3,
      }];
      if (companyAreaId && companyCityId && companyProvinceId) {
        relationList.forEach((item) => {
          this.company[`areaLevel${item.level}`] = {
            id: this.certInfo.licenseData[item.key],
          };
        });
      } else {
        this.company = {
          areaLevel1: null,
          areaLevel2: null,
          areaLevel3: null,
        };
      }
    },
    // 获取地址信息
    async getAreaInfo(level, otherInfo = {}) {
      // 正式调用
      const params = {};
      if (Object.keys(otherInfo).length !== 0) {
        params.parentId = otherInfo.id;
      }
      const res = await areaList(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        this[`areaLevel${level}Info`] = data.list;
        if (level === 1) {
          this.areaLevel2Info = [];
          this.areaLevel3Info = [];
        } else if (level === 2) {
          this.areaLevel3Info = [];
        }
      } else {
        this.$message.error('获取地区信息失败');
      }
    },
    isCheck(ref) {
      return new Promise((resolve) => {
        this.$refs[ref].validate((valid) => {
          resolve(valid);
        });
      });
    },
    // 校验
    async check(ref) {
      const isPass = await this.isCheck(ref);
      return isPass;
    },
    // 修改验证 & 人脸识别
    async checkAll(needFace = true) {
      const {
        idCardBackImgUrl,
        idCardFrontImgUrl,
        licenseImgUrl,
        agentPowerAttorneyImgUrl,
        agentIdCardFrontImgUrl,
        agentIdCardBackImgUrl,
      } = this.certInfo;

      let text = '';
      if (!licenseImgUrl) {
        text = '营业执照';
      } else if (!idCardBackImgUrl || !idCardFrontImgUrl) {
        text = '法人身份证照片';
      } else if (this.agent) { // 代办人认证，额外校验授权书和代办人身份证
        if (!agentPowerAttorneyImgUrl) {
          text = '授权委托书';
        } else if (!agentIdCardFrontImgUrl || !agentIdCardBackImgUrl) {
          text = '代办人身份证照片';
        }
      }
      if (text) {
        this.$message({
          message: `请上传${text}后再进行提交认证`,
          type: 'warning',
        });
        return;
      }

      const licensePass = await this.check('licenseForm'); // 营业执照信息校验
      const idCardPass = await this.check('idCardForm'); // 身份证信息校验
      const phonePass = await this.check('phoneForm'); // 联系人手机号校验

      if (!licensePass) {
        this.$message({
          message: '请检查营业执照信息填写，修改或重新上传后再提交',
          type: 'warning',
        });
      } else if (!idCardPass) {
        this.$message({
          message: '请检查身份信息填写，修改或重新上传后再提交',
          type: 'warning',
        });
      } else if (!phonePass) {
        this.$message({
          message: '请检查联系人手机号信息填写，修改后再提交',
          type: 'warning',
        });
      }

      if (licensePass && idCardPass && phonePass) {
        if (needFace) {
          this.showFace();
        } else {
          this.submit();
        }
      }
    },
    // 确认修改
    async submit(authNo = null) {
      const { idCardBackImgUrl, idCardFrontImgUrl, licenseImgUrl } = this.certInfo;
      this.certInfo.licenseData.companyProvinceId = this.company.areaLevel1.id;
      this.certInfo.licenseData.companyCityId = this.company.areaLevel2.id;
      this.certInfo.licenseData.companyAreaId = this.company.areaLevel3.id;

      try {
        const eid = await this.getEid();
        const params = {
          idCardBackImgUrl,
          idCardData: this.certInfo.idCardData,
          idCardFrontImgUrl,
          licenseData: this.certInfo.licenseData,
          licenseImgUrl,
          phone: this.certInfo.phone,
          authNo,
          eid,
          authType: this.agent ? 2 : 1,
        };

        if (this.agent) {
          params.agentPowerAttorneyImgUrl = this.certInfo.agentPowerAttorneyImgUrl;
          params.agentIdCardFrontImgUrl = this.certInfo.agentIdCardFrontImgUrl;
          params.agentIdCardBackImgUrl = this.certInfo.agentIdCardBackImgUrl;
        }

        this.loading = true;
        const res = await certSubmit(params);
        const {
          code, data, message,
        } = res;
        this.loading = false;
        if (code === 200) {
          const authStatus = Number(data.authStatus);

          if (authStatus === 2) {
            this.$router.push({
              name: 'authWait',
            });
            return;
          }

          this.certInfo.authStatus = authStatus;
          // 更新认证状态
          store.commit('setAuthStatus', this.certInfo.authStatus);
          if (this.certInfo.authStatus === 3) {
            this.$message({
              message: '企业认证成功',
              type: 'success',
              onClose: () => {
                this.$router.push({ name: 'hasAuth' });
              },
            });
          } else if (data.riskErrorMsg && data.riskErrorMsg.length > 0) {
            // 风控异常，使用强提醒
            this.$alert(data.riskErrorMsg.join('、'));
          } else {
            this.$message.error('认证失败，请修改内容后重新提交');
          }
          this.certInfo.idCardErrorMsg = data.idCardErrorMsg;
          this.certInfo.licenseErrorMsg = data.licenseErrorMsg;
          this.certInfo.riskErrorMsg = data.riskErrorMsg;
          if (this.agent) {
            this.certInfo.agentIdCardErrorMsg = data.agentIdCardErrorMsg;
          }
        } else {
          this.$message.error(message || '提交认证信息失败');
        }
      } catch (e) {
        this.$message.error(e.message || '提交认证信息失败');
      }
    },
    // 再次上传完成更新
    async updateAuthForm(params) {
      const {
        prop, imgUrl, ocrInfo, infoType,
      } = params;

      // 解密图片更新
      await this.download(imgUrl, `${prop}Path`);
      this.certInfo[prop] = imgUrl;

      if (infoType) {
        this.certInfo[infoType] = { ...this.certInfo[infoType], ...ocrInfo[infoType] };

        // 营业执照
        if (infoType === 'licenseData') {
          // this.certInfo.licenseData.companyAreaId = [];
          this.init = true;
          this.getAreaInfo(1);
          // 省市区回显
          this.initArea();
        }
      }
    },
    // 展示人脸识别弹窗
    showFace() {
      this.faceVisible = true;
    },
    // 关闭人脸识别弹窗
    closeFace(authNo = null) {
      this.faceVisible = false;
      if (authNo) {
        this.submit(authNo);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-upload-auth {
  padding: 30px 20px 54px;
  width: 100%;
  box-sizing: border-box;
  .mb20 {
    margin-bottom: 20px;
  }
  .top-box {
    margin-bottom: 15px;
    width: 100%;
    line-height: 18px;

    .big-title {
      font-size: 18px;
      color: rgba(0,0,0,1);
      font-weight: 600;
    }
  }

  .cert-result-box {
    margin: 0 auto;
    // width: 80%;
    box-sizing: border-box;
    text-align: left;
    .item-title {
      margin: 10px 0 10px 10px;
      width: 100%;
      padding-left: 5px;
      font-size: 14px;
      color: #333333;
      font-weight: 500;
      line-height: 14px;
      border-left: 4px solid #4d80f0;
      box-sizing: border-box;
      &.mt30 {
        margin-top: 30px;
      }
    }

    .info-box {
      padding-top: 5px;
      display: flex;
      box-sizing: border-box;

      .right-img-box {
        width: 400px;
        height: 488px;
        box-sizing: border-box;
        background: rgba(250,250,250,1);
        border-radius: 2px;
        &.card-right {
          height: 344px;
        }
        .demo-box {
          padding-top: 30px;
          text-align: center;
          .demo-title {
            margin-bottom: 20px;
            display: inline-block;
            line-height: 12px;
            font-size: 12px;
            color: rgba(38,38,38,1);
          }
          .demo-img-box {
            display: flex;
            justify-content: center;
            .demo-license {
              margin: 0 auto;
              display: block;
              width: 300px;
              height: 204px;
              // box-shadow:  0px 0px 4px 0px rgba(0,0,0,0.1);
              // background: rgba(255,255,255,1);
              // border-radius: 2px;
            }
            .mr20 {
              margin-right: 20px;
            }
            .demo-id-card {
              width: 145px;
              height: 92px;
              // box-shadow:  0px 0px 4px 0px rgba(0,0,0,0.1);
              // background: rgba(255,255,255,1);
              // border-radius: 2px;
            }
          }
        }
      }

      .left-info-box {
        margin-right: 85px;
        width: 460px;
        .img-desc {
          margin-top: 10px;
          font-size: 12px;
          color: rgba(0,0,0,0.45);
          line-height: 12px;
          line-height: 1.333;
        }
        .uploader-box {
          margin-right: 20px;
        }
      }
      .ml10 {
        margin-left: 10px;
      }
      .w100:first-child {
        margin-left: 0;
      }
      .w100 {
        margin-left: 10px;
        width: 106px;
      }
    }

    .url-link {
      color: #4d80f0;
    }
    .phone-form {
      padding-left: 10px;
      box-sizing: border-box;
    }

    .btn-box {
      margin-top: 30px;
      margin-left: 118px;
    }
  }
}
</style>
